/**
 * taskHref — wohin ein Nexus-Background-Task im Header verlinkt.
 *
 * Bis 2026-08 zeigten ALLE Task-Links auf /developer/projects/<project_id>.
 * Für Nexus-Core-Tasks (task_scope='core', project_id IS NULL) war das falsch:
 * sie leben unter /nexus/core/<session_id>. Die Session-ID liefert das Backend
 * jetzt aus nexus_background_tasks.context.$.session_id mit (get_user_tasks).
 */
export function isCoreTask(task) {
  if (!task) return false
  return task.task_scope === 'core' || (!task.project_id && task.task_scope !== 'project')
}

export function taskHref(task) {
  if (isCoreTask(task)) {
    return task.session_id ? `/nexus/core/${task.session_id}` : '/nexus/core'
  }
  return task.project_id ? `/developer/projects/${task.project_id}` : '/developer'
}

/** Ziel des "Alle ... anzeigen"-Footer-Links, abhängig von den sichtbaren Tasks. */
export function taskListHref(tasks = []) {
  const hasCore = tasks.some(isCoreTask)
  const hasProject = tasks.some((t) => !isCoreTask(t))
  if (hasCore && !hasProject) return '/nexus/core'
  return '/developer'
}

/**
 * Ziel-FENSTER: beide Bereiche gehen in einem eigenen, WIEDERVERWENDETEN Tab auf
 * (benanntes window-target). Zweiter Klick auf einen Core-Task landet also im
 * selben "nexus-core"-Tab statt einen dritten zu öffnen.
 */
export function taskTarget(task) {
  return isCoreTask(task) ? 'nexus-core' : 'nexus-developer'
}

export function taskListTarget(tasks = []) {
  return taskListHref(tasks) === '/nexus/core' ? 'nexus-core' : 'nexus-developer'
}
